import React from 'react';

const AngelButton = ({ onClick, href, imgSrc, text = "Ask Angel", ...props }) => {
  const imgCDNURL = process.env.REACT_APP_CDN + "swmc-niches/";
  
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <div className="angel-button-wrapper">
    <a
      className="link"
      href={"https://www.swmc.com/angelai"}
      target="_blank"
      // onClick={handleClick}
      // {...props}
    >
      <img 
        src={imgCDNURL + "ballerina.gif"} 
        className="angel-image" 
        alt="Angel" 
      />
      </a>
      <a
        className="angel-button"
        href={href || "#"}
        onClick={handleClick}
        {...props}
      >
        <div className="angel-button-content">
          <span className="angel-text">{text}</span>
        </div>
        <div className="angel-glass-effect"></div>
      </a>
    </div>
  );
};

export default AngelButton;

// Styles
const styles = `
  .angel-button-wrapper {
    display: inline-block;
    margin-top: 50px;
    position: relative;
  }

  .angel-button {
    position: relative;
    display: flex;
    align-items: center;
    text-decoration: none;
    border-radius: 25px;
    border: 2px solid #FFF;
    background: linear-gradient(90deg, #FF2E00 0%, rgba(255, 136, 0, 0.80) 100%);
    padding: 15px 30px 15px 100px;
    color: white;
    font-weight: 700;
    font-size: 1.8rem;
    cursor: pointer;
    transition: transform 0.2s ease;
    outline: none;
    min-height: 60px;
    box-shadow: 0 4px 15px rgba(255, 46, 0, 0.3);
    overflow: hidden;
  }

  .angel-button:hover {
    box-shadow: 0 6px 20px rgba(255, 46, 0, 0.4);
    color: white;
    text-decoration: none;
  }

  .angel-button:active {
    transform: translateY(0);
  }

  .angel-button:focus {
    color: white;
    text-decoration: none;
  }

  .angel-button-content {
    position: relative;
    z-index: 3;
    width: 100%;
  }

  .angel-image {
    position: absolute;
    width: 90px;
    height: 120px;
    object-fit: cover;
    top: -45px;
    left: 10px;
    z-index: 4;
    border-radius: 10px;
  }

  .angel-text {
    position: relative;
    z-index: 3;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }

  .angel-glass-effect {
    position: absolute;
    top: 0;
    left: -150%;
    width: 150%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.4) 40%,
      rgba(255, 255, 255, 0.6) 50%,
      rgba(255, 255, 255, 0.4) 60%,
      transparent 100%
    );
    animation: angelGlassSlide 4s infinite ease-in-out;
    z-index: 2;
  }

  @keyframes angelGlassSlide {
    0% {
      left: -150%;
    }
    50% {
      left: 150%;
    }
    100% {
      left: -150%;
    }
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = styles;
  document.head.appendChild(styleElement);
}